import Controls from "../components/Controls";
import { useTranslation } from "../components/Localization";
import RoomHeader from "../components/RoomHeader";

export default function EstateScorePage() {
  const { t } = useTranslation();
  return <main className="screen score estate-score">
    <RoomHeader roomId="estate" />
    <div className="score-copy"><strong>{t("common.completed")}</strong><div>{Array.from({ length: 3 }, (_, index) => <i key={index} />)}</div><span>3/3</span></div>
    <Controls backTo="/petkiek/csaladfa" nextTo="/mariaffiek" />
  </main>;
}
